export const iconFontAwesomeCommunicationBlenderPhone = (
	<i className="fa-solid fa-blender-phone"></i>
);
